module.exports = __webpack_public_path__ + "static/media/ticket-footer.5655faf7.png";